import * as React from "react";
import C from "classnames";
export const InputGroupText = ({ children, className, testId, }) => {
    return (React.createElement("div", { className: C("input-group-text", className && className), "data-testid": testId }, children));
};
//# sourceMappingURL=InputGroupText.js.map